document.addEventListener('DOMContentLoaded', () => {
  const wheels = document.querySelectorAll('.skullhead__wheel');

  wheels.forEach((wheel) => {
    const svg = wheel.querySelector('svg'),
      path = svg.querySelector('#path'),
      textEl = svg.querySelector('.text'),
      bbox = path.getBBox(),
      cx = bbox.x + bbox.width / 2,
      cy = bbox.y + bbox.height / 2;

    textEl.style.transformBox = 'view-box';
    textEl.style.transformOrigin = `${cx}px ${cy}px`;

    let lastY = window.pageYOffset,
      angle = 0,
      speed = 0.09;

    window.addEventListener('scroll', () => {
        const nowY = window.pageYOffset, delta = nowY - lastY;
        angle += delta * speed;
        textEl.style.transform = `rotate(${angle}deg)`;
        lastY = nowY;
      },
      { passive: true }
    );
  });
});
